import { useQuery } from "@tanstack/react-query";
import { getPublicRecoveryPlan } from "../api/getPublicRecoveryPlan";
import { QUERY_KEYS } from "@/shared/api/query-keys";

export const usePublicRecoveryPlan = (planId: string) => {
  return useQuery({
    queryKey: [QUERY_KEYS.PUBLIC_CLINIC, planId],
    queryFn: () => getPublicRecoveryPlan(planId),
    enabled: !!planId, // Evita disparar la petición si el planId no está listo en la URL
  });
};